import { OVERALL_RESULT_VALUES } from '@/constants/api/emergencyInspectionResult/emergencyAssessment/overallResult'
import { AI_LABEL_BUILDING } from '@/constants/api/aiBuilding/aiLabelBuilding'
import { EMERGENCY_S3_DIRECTORY_NAMES } from '@/constants/s3/directoryName'

/** 1ページに表示する画像枚数 */
export const CHUNK_SIZE = 4

/** 表示対象の画像データが存在しない場合のメッセージ */
export const NO_IMAGE_MESSAGE = '画像データがありません'

/** 画像表示対象の調査項目の選択肢（応急危険度判定） */
export const EMERGENCY_INSPECTION_OPTIONS = [
  { key: EMERGENCY_S3_DIRECTORY_NAMES.EXTERIOR, label: '一見して危険と判定される' },
  {
    key: EMERGENCY_S3_DIRECTORY_NAMES.SURROUNDING,
    label: '隣接建築物・周辺地盤の破壊による危険'
  },
  {
    key: EMERGENCY_S3_DIRECTORY_NAMES.DIFFERENTIAL_SETTLEMENT,
    label: '構造躯体の不動沈下'
  },
  { key: EMERGENCY_S3_DIRECTORY_NAMES.BASICS, label: '基礎' },
  { key: EMERGENCY_S3_DIRECTORY_NAMES.FIRST_FLOOR_SLOPE, label: '建築物の 1 階の傾斜' },
  { key: EMERGENCY_S3_DIRECTORY_NAMES.WALL, label: '壁' },
  { key: EMERGENCY_S3_DIRECTORY_NAMES.CORROSION_OR_TERMITE, label: '腐食・蟻害の有無' },
  { key: EMERGENCY_S3_DIRECTORY_NAMES.ROOF_TILE, label: '瓦' },
  { key: EMERGENCY_S3_DIRECTORY_NAMES.WINDOW_FRAME, label: '窓枠・窓ガラス' },
  {
    key: EMERGENCY_S3_DIRECTORY_NAMES.EXTERIOR_WET_MATERIAL,
    label: '外装材（モルタル、タイル・石張り等）'
  },
  {
    key: EMERGENCY_S3_DIRECTORY_NAMES.EXTERIOR_DRY_MATERIAL,
    label: '外装材（ALC 板・PC 板・金属・ブロック等）'
  },
  { key: EMERGENCY_S3_DIRECTORY_NAMES.SIGNBOARD, label: '看板･機器類' },
  { key: EMERGENCY_S3_DIRECTORY_NAMES.OUTDOOR_STAIRS, label: '屋外階段' },
  {
    key: EMERGENCY_S3_DIRECTORY_NAMES.SETTLEMENT_SLOPE,
    label: '不同沈下による建築物全体の傾斜'
  },
  {
    key: EMERGENCY_S3_DIRECTORY_NAMES.SETTLEMENT_SLOPE_STEEL,
    label: '不同沈下による建築物全体の傾斜'
  },
  {
    key: EMERGENCY_S3_DIRECTORY_NAMES.ABOVE_SLOPE_FLOOR_LEVEL,
    label: '傾斜を生じた階の上の階数'
  },
  { key: EMERGENCY_S3_DIRECTORY_NAMES.SLOPE, label: '建築物全体又は一部の傾斜' },
  { key: EMERGENCY_S3_DIRECTORY_NAMES.BUCKLING, label: '部材の座屈の有無' },
  { key: EMERGENCY_S3_DIRECTORY_NAMES.BRACE, label: '筋違の破断率' },
  {
    key: EMERGENCY_S3_DIRECTORY_NAMES.PILLAR_BEAM_JOINT,
    label: '柱梁の接合部及び継手の破壊'
  },
  { key: EMERGENCY_S3_DIRECTORY_NAMES.PILLAR_BASE, label: '柱脚の破損' },
  { key: EMERGENCY_S3_DIRECTORY_NAMES.CORROSION, label: '腐食の有無' },
  { key: EMERGENCY_S3_DIRECTORY_NAMES.ROOF_MATERIAL, label: '屋根材' },
  {
    key: EMERGENCY_S3_DIRECTORY_NAMES.PARTS_DAMAGE_GTE_3,
    label: '損傷度 Ⅲ 以上の損傷部材の有無'
  },
  {
    key: EMERGENCY_S3_DIRECTORY_NAMES.GROUND_DESTRUCTION_SETTLEMENT,
    label: '地盤破壊による建築物全体の沈下'
  },
  {
    key: EMERGENCY_S3_DIRECTORY_NAMES.PILLAR_DAMAGE_FLOOR,
    label: '柱の被害 被害最大の階'
  },
  {
    key: EMERGENCY_S3_DIRECTORY_NAMES.PILLAR_DAMAGE_5,
    label: '損傷度 Ⅴ の柱本数/調査柱本数'
  },
  {
    key: EMERGENCY_S3_DIRECTORY_NAMES.PILLAR_DAMAGE_4,
    label: '損傷度 Ⅳ の柱本数/調査柱本数'
  },
  { key: EMERGENCY_S3_DIRECTORY_NAMES.OTHER_ITEM, label: 'その他' },

  { key: EMERGENCY_S3_DIRECTORY_NAMES.OVERALL_RESULT, label: '判定ステッカー' }
]

/** 応急危険度判定の結果ラベル */
export const EMERGENCY_OVERALL_RESULT_LABEL = {
  [OVERALL_RESULT_VALUES.RANK_A]: { label: '調査済' },
  [OVERALL_RESULT_VALUES.RANK_B]: { label: '要注意' },
  [OVERALL_RESULT_VALUES.RANK_C]: { label: '危険' }
} as const

/** AI倒壊判定結果ラベル */
export const AI_LABEL_BUILDING_LABEL = {
  [AI_LABEL_BUILDING.notCollapsed]: { label: '非全壊' },
  [AI_LABEL_BUILDING.collapsed]: { label: '全壊' }
}

/** 木造の調査項目リスト（応急危険度判定） */
export const EMERGENCY_WOOD_INSPECTION_OPTIONS = [
  EMERGENCY_S3_DIRECTORY_NAMES.EXTERIOR,
  EMERGENCY_S3_DIRECTORY_NAMES.SURROUNDING,
  EMERGENCY_S3_DIRECTORY_NAMES.DIFFERENTIAL_SETTLEMENT,
  EMERGENCY_S3_DIRECTORY_NAMES.BASICS,
  EMERGENCY_S3_DIRECTORY_NAMES.FIRST_FLOOR_SLOPE,
  EMERGENCY_S3_DIRECTORY_NAMES.WALL,
  EMERGENCY_S3_DIRECTORY_NAMES.CORROSION_OR_TERMITE,
  EMERGENCY_S3_DIRECTORY_NAMES.ROOF_TILE,
  EMERGENCY_S3_DIRECTORY_NAMES.WINDOW_FRAME,
  EMERGENCY_S3_DIRECTORY_NAMES.EXTERIOR_WET_MATERIAL,
  EMERGENCY_S3_DIRECTORY_NAMES.EXTERIOR_DRY_MATERIAL,
  EMERGENCY_S3_DIRECTORY_NAMES.SIGNBOARD,
  EMERGENCY_S3_DIRECTORY_NAMES.OUTDOOR_STAIRS,
  EMERGENCY_S3_DIRECTORY_NAMES.OTHER_ITEM
]

/** 鉄骨造の調査項目リスト（応急危険度判定） */
export const EMERGENCY_STEEL_INSPECTION_OPTIONS = [
  EMERGENCY_S3_DIRECTORY_NAMES.EXTERIOR,
  EMERGENCY_S3_DIRECTORY_NAMES.SURROUNDING,
  EMERGENCY_S3_DIRECTORY_NAMES.SETTLEMENT_SLOPE_STEEL,
  EMERGENCY_S3_DIRECTORY_NAMES.SLOPE,
  EMERGENCY_S3_DIRECTORY_NAMES.BUCKLING,
  EMERGENCY_S3_DIRECTORY_NAMES.BRACE,
  EMERGENCY_S3_DIRECTORY_NAMES.PILLAR_BEAM_JOINT,
  EMERGENCY_S3_DIRECTORY_NAMES.PILLAR_BASE,
  EMERGENCY_S3_DIRECTORY_NAMES.CORROSION,
  EMERGENCY_S3_DIRECTORY_NAMES.ROOF_MATERIAL,
  EMERGENCY_S3_DIRECTORY_NAMES.WINDOW_FRAME,
  EMERGENCY_S3_DIRECTORY_NAMES.EXTERIOR_WET_MATERIAL,
  EMERGENCY_S3_DIRECTORY_NAMES.EXTERIOR_DRY_MATERIAL,
  EMERGENCY_S3_DIRECTORY_NAMES.SIGNBOARD,
  EMERGENCY_S3_DIRECTORY_NAMES.OUTDOOR_STAIRS,
  EMERGENCY_S3_DIRECTORY_NAMES.OTHER_ITEM
]

/** 鉄筋及び鉄骨鉄筋コンクリート造ごとの調査項目リスト（応急危険度判定） */
export const EMERGENCY_RC_INSPECTION_OPTIONS = [
  EMERGENCY_S3_DIRECTORY_NAMES.EXTERIOR,
  EMERGENCY_S3_DIRECTORY_NAMES.PARTS_DAMAGE_GTE_3,
  EMERGENCY_S3_DIRECTORY_NAMES.SURROUNDING,
  EMERGENCY_S3_DIRECTORY_NAMES.GROUND_DESTRUCTION_SETTLEMENT,
  EMERGENCY_S3_DIRECTORY_NAMES.SETTLEMENT_SLOPE,
  EMERGENCY_S3_DIRECTORY_NAMES.PILLAR_DAMAGE_5,
  EMERGENCY_S3_DIRECTORY_NAMES.PILLAR_DAMAGE_4,
  EMERGENCY_S3_DIRECTORY_NAMES.WINDOW_FRAME,
  EMERGENCY_S3_DIRECTORY_NAMES.EXTERIOR_WET_MATERIAL,
  EMERGENCY_S3_DIRECTORY_NAMES.EXTERIOR_DRY_MATERIAL,
  EMERGENCY_S3_DIRECTORY_NAMES.SIGNBOARD,
  EMERGENCY_S3_DIRECTORY_NAMES.OUTDOOR_STAIRS,
  EMERGENCY_S3_DIRECTORY_NAMES.OTHER_ITEM
]
